import { render, staticRenderFns } from "./addstorestatelist.vue?vue&type=template&id=2f2bbfc6&scoped=true&"
import script from "./addstorestatelist.vue?vue&type=script&lang=js&"
export * from "./addstorestatelist.vue?vue&type=script&lang=js&"
import style0 from "./addstorestatelist.vue?vue&type=style&index=0&id=2f2bbfc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2bbfc6",
  null
  
)

export default component.exports